module.exports = __webpack_public_path__ + "static/media/black-polygon-measure-icon.cbb1da47.svg";